import { useState } from 'react';

const useForm = (initialValues, validate) => {
    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setValues({
        ...values,
        [name]: value
        });

        // Clear error when user starts typing
        if (errors[name]) {
        setErrors({
            ...errors,
            [name]: ''
        });
        }
    };

    const handleSubmit = async (onSubmit) => {
        setIsSubmitting(true);
        
        // Validate form
        const validationErrors = validate ? validate(values) : {};
        setErrors(validationErrors);

        if (Object.keys(validationErrors).length === 0) {
        await onSubmit(values);
        }

        setIsSubmitting(false);
    };

    const resetForm = () => {
        setValues(initialValues);
        setErrors({});
    };

    return {
        values,
        errors,
        isSubmitting,
        handleChange,
        handleSubmit,
        resetForm,
        setValues
    };
};

export default useForm;